import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PasswordComponent } from './password/password.component';
import { HomeComponent } from './home/home.component';
import { DetailComponent } from './detail/detail.component';
import { CalendarComponent } from './calendar/calendar.component';
import { TasksComponent } from './tasks/tasks.component';
import { SalaryComponent } from './salary/salary.component';
import { GroupsComponent } from './groups/groups.component';
import { DepartmentComponent } from './groups/department/department.component';
import { AnnouncementComponent } from './announcement/announcement.component';
import { MailComponent } from './mail/mail.component';
import { BirthdaysComponent } from './birthdays/birthdays.component';
import { LeaveComponent } from './leave/leave.component';
import { SearchComponent } from './search/search.component';
import { DocumentsComponent } from './documents/documents.component';
import { CarbookingComponent } from './carbooking/carbooking.component';
import { NewsComponent } from './news/news.component';
import { AuthGuard } from './helpers/auth.guard';
import { OrganizationComponent } from './groups/organization/organization.component';
import { EmployeeComponent } from './groups/employee/employee.component';
import { TimekeepingComponent } from './timekeeping/timekeeping.component';
import { WorkreportComponent } from './workreport/workreport.component';
import { AddWorkreportComponent } from './workreport/add/add.component';
import { EditWorkreportComponent } from './workreport/edit/edit.component';
import { WorkscheduleComponent } from './workschedule/workschedule.component';

// import { MetaGuard } from '@ngx-meta/core';

const routes: Routes = [
  { 
    path: 'home', 
    redirectTo: 'home', 
    pathMatch: 'full' 
  },
  {
    path: 'login',
    // canActivate: [MetaGuard],
    component: LoginComponent,
    data: {
      meta: {
        title: 'LOGIN.PAGE_TITLE'
      }
    }
  },
  {
    path: 'forgot-password/:email/:token',
    component: PasswordComponent,
  },
  {
    canActivate: [AuthGuard],
    path: 'home',
    component: HomeComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'post/:name', 
    component: DetailComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'settings', 
    loadChildren: './settings/settings.module#SettingsModule'
  },
  { 
    canActivate: [AuthGuard],
    path: 'chat',
    loadChildren: './chat/chat.module#ChatModule'
  },
  { 
    canActivate: [AuthGuard],
    path: 'calendar',
    component: CalendarComponent,
  },
  { 
    path: 'schedule',
    component: WorkscheduleComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'tasks',
    component: TasksComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'salary',
    component: SalaryComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'department',
    component: GroupsComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'organization',
    component: OrganizationComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'department/:name',
    component: DepartmentComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'announcement',
    component: AnnouncementComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'employee',
    component: EmployeeComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'mail',
    component: MailComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'birthday',
    component: BirthdaysComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'leave',
    component: LeaveComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'search',
    component: SearchComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'documents',
    component: DocumentsComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'admin', 
    loadChildren: './admin/admin.module#AdminModule'
  },
  { 
    canActivate: [AuthGuard],
    path: 'carbooking',
    component: CarbookingComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'news',
    component: NewsComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'timekeeping',
    component: TimekeepingComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'report',
    component: WorkreportComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'report/add',
    component: AddWorkreportComponent,
  },
  { 
    canActivate: [AuthGuard],
    path: 'report/edit/:id',
    component: EditWorkreportComponent,
  },
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
